import React from 'react';
import Spinner from 'react-spinkit';

export class Loading extends React.Component {
	render() {
		const style = {
			width: 60,
			margin: '0 auto',
			paddingTop: 150
		};
		return (
			<Spinner
				color={this.props.color ? this.props.color : '#444'}
				fadeIn="none"
				name="three-bounce"
				style={style}
			/>
		);
	}
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading/index.js